<div class="select-container" (click)="open()">
  <div class="input-container">
    @if (selectedObject) {
      <div class="selected-pill">
        <fa-icon [icon]="selectedObject.icon"></fa-icon>
        <span class="object-title">{{ selectedObject.title }}</span>
        <button class="remove-button" (click)="removeSelection($event)">
          ×
        </button>
      </div>
    } @else {
      <input
        #inputElement
        [formControl]="searchControl"
        placeholder="{{ 'data-object-select.placeholder' | translate }}"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown)="onKeyDown($event)"
      />
      @if (suggestionsLoading) {
        <app-loading></app-loading>
      }
    }
  </div>
  @if (isOpen) {
    <div class="dropdown">
      <ul #dropdownList>
        @for (
          object of filteredObjects;
          track trackById(i, object);
          let i = $index
        ) {
          <li
            (click)="selectObject(object)"
            [class.highlighted]="i === highlightedIndex"
          >
            @if (object.icon) {
              <fa-icon [icon]="object.icon" />
            }
            <span
              class="object-title"
              [innerHTML]="object.title | highlight: searchControl.value"
            ></span>
          </li>
        }
      </ul>
    </div>
  }
</div>
